// extracted by mini-css-extract-plugin
export var pc_container = "index-module--pc_container--8651d";